module.exports = __webpack_public_path__ + "img/WechatIMG603.397f41e2.jpg";